import api from './api';

export interface Subscription {
  id: string;
  status: string;
  type: string;
  trialStartDate: string;
  trialEndDate: string;
  subscriptionStartDate: string;
  subscriptionEndDate: string;
  hasActiveAccess: boolean;
}

export interface CheckoutSession {
  id: string;
  url: string;
}

export const getSubscription = async (): Promise<Subscription> => {
  const response = await api.get('/api/subscriptions/current');
  return response.data;
};

export const createCheckoutSession = async (): Promise<CheckoutSession> => {
  const response = await api.post('/api/subscriptions/checkout');
  return response.data;
};

export const cancelSubscription = async (): Promise<void> => {
  await api.post('/api/subscriptions/cancel');
};
